/* eslint-disable no-underscore-dangle */
import type { mxCell, mxGraph } from '@deity-io/mxgraph';
import type { FlowContextInterface, IConnectPayload } from 'contexts/FlowContext';
import { FlowActionTypes } from 'contexts/FlowContext';
import mx from 'services/mxGraph/mx';
import { connectPayload } from '../../helpers/flowHelpers';

export const menuFactory = (
  menu: any,
  cell: mxCell,
  event: any,
  graph: { current?: mxGraph },
  ctx: FlowContextInterface | null,
  isEditable: boolean
) => {
  try {
    if (cell) {
      if (cell.edge === true) {
        // @todo, make isContentLocked recursive
        if (isEditable && cell.parent?.isLocked !== true && cell.parent?.isContentLocked !== true) {
          menu.addItem('Disconnect', null, () => {
            const payload: IConnectPayload | undefined = connectPayload(cell.source, cell.target);
            if (payload) {
              ctx?.dispatch({
                type: FlowActionTypes.DISCONNECT,
                payload
              });
            }
            graph.current?.removeCells([cell]);
            mx.mxEvent.consume(event);
          });

          menu.addItem('Clear Waypoints', null, () => {
            cell.geometry.points = []; // const payload: IConnectPayload | undefined = connectPayload(cell.source, cell.target);
            graph.current?.refresh(cell);

            ctx?.dispatch({
              type: FlowActionTypes.UPDATE_CONNECTION_WAYPOINTS,
              payload: {
                componentId: cell.source.parent.value.compId,
                port: cell.source.value.key,
                waypoints: []
              }
            });

            mx.mxEvent.consume(event);
          });
        }
        // menu.addItem('Show the pipe flow', null, () => {
        //   const state = graph.current.view.getState(cell);
        //   graph.current.orderCells(true, [cell]);
        //   state.shape.node.getElementsByTagName('path')[0].removeAttribute('visibility');
        //   state.shape.node.getElementsByTagName('path')[0].setAttribute('stroke-width', '6');
        //   state.shape.node.getElementsByTagName('path')[0].setAttribute('stroke', 'lightGray');
        //   state.shape.node.getElementsByTagName('path')[1].setAttribute('class', 'flow');
        // });
      } else if (!cell.isPort) {
        if (isEditable) {
          if (cell.disableDelete !== true && cell.isLocked !== true && cell.parent?.isContentLocked !== true) {
            menu.addItem('Remove Component', null, () => {
              if (cell.value?.compId) {
                ctx?.dispatch({
                  type: FlowActionTypes.REMOVE_COMPONENT,
                  payload: cell.value.compId
                });
              }
              graph.current?.removeCells([cell]);
              mx.mxEvent.consume(event);
            });
          }
        }

        menu.addItem(`${isEditable ? 'Edit' : 'View'} Component Settings`, null, () => {
          const selectedCompId = cell.value.compId;
          if (selectedCompId) {
            ctx?.dispatch({ type: FlowActionTypes.SELECT_COMPONENT, payload: { componentId: selectedCompId } });
          }
          ctx?.dispatch({
            type: FlowActionTypes.TOGGLE_PANEL,
            payload: 'CONFIG_COMPONENT'
          });
        });
      }
    }

    if (!cell) {
      if (isEditable) {
        menu.addItem('Show component panel', null, () => {
          ctx?.dispatch({ type: FlowActionTypes.TOGGLE_PANEL, payload: 'ADD_COMPONENT' });
        });
      }
      menu.addItem('JSON Preview', null, () => {
        ctx?.dispatch({ type: FlowActionTypes.TOGGLE_PANEL, payload: 'JSON_VIEWER' });
      });
    }
    menu.addItem('Fit to View', null, () => {
      graph.current?.fit(0);
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`Error occurred in menuFactory. Message "${err}"`);
  }
};
